import React, { useState, useEffect } from "react";
import Wrappers from "../shared/Wrappers";
import CustomerDetailsFilter from "../customer/CustomerDetailsFilter";
import HeaderBreadcrumb from "../shared/HeaderBreadcrumb";
import PersonalDetailsForm from "./PersonalDetailsForm";
import VehicleDetails from "./VehicleDetails";
import LicenseDetails from "./LicenseDetails";
import Bookings from "./Bookings";
import Earnings from "./Earnings";
import { ItemsMain } from "./styles/PersonalDetailStyle";
import { useParams } from "react-router-dom";
import { GetDriverByID } from "../../../services/admin/drivers";
import Loader from "../../shared/loader";

const PersonalDetails = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [AllData, setAllData] = useState([]);

  const [activeBtn, SetactiveBtn] = useState(0);
  const DriverName = AllData?.data?.user?.name || "Driver name";

  const FilterButton = [
    "Personal Details",
    "Vehicle Details",
    "License Details",
    "Bookings",
    "Earnings",
    // "Transactions",
  ];

  const customerHeader = ["Drivers", DriverName, "Details", "Personal Details"];
  const VehicleHeader = ["Drivers", DriverName, "Details", "Vehicle Details"];
  const LicenseHeader = ["Drivers", DriverName, "Details", "License Details"];
  const bookingHeader = ["Drivers", DriverName, "Details", "Active bookings"];
  const EarningsHeader = ["Drivers", DriverName, "Details", "Earnings"];

  useEffect(() => {
    getSingleDrivers();
  }, [id]);

  const getSingleDrivers = async () => {
    await GetDriverByID(setLoading, setAllData, id);
  };
  const { data } = AllData || [];

  return (
    <Wrappers>
      {loading && <Loader />}
      {activeBtn === 0 && (
        <HeaderBreadcrumb ItemsName={customerHeader} GoTo="/admin/drivers" />
      )}
      {activeBtn === 1 && (
        <HeaderBreadcrumb ItemsName={VehicleHeader} GoTo="/admin/drivers" />
      )}
      {activeBtn === 2 && (
        <HeaderBreadcrumb ItemsName={LicenseHeader} GoTo="/admin/drivers" />
      )}
      {activeBtn === 3 && (
        <HeaderBreadcrumb ItemsName={bookingHeader} GoTo="/admin/drivers" />
      )}
      {activeBtn === 4 && (
        <HeaderBreadcrumb ItemsName={EarningsHeader} GoTo="/admin/drivers" />
      )}
      <CustomerDetailsFilter
        FilterButton={FilterButton}
        clickHandler={SetactiveBtn}
        activeBtn={activeBtn}
        width={true}
      />
      {activeBtn === 0 && <PersonalDetailsForm data={data?.user} />}
      {activeBtn === 1 && <VehicleDetails data={data?.user?.vehicle} />}
      {activeBtn === 2 && <LicenseDetails data={data?.user?.license} />}
      <ItemsMain>
        {activeBtn === 3 && <Bookings />}
        {activeBtn === 4 && <Earnings />}
      </ItemsMain>
    </Wrappers>
  );
};

export default PersonalDetails;
